var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBullhorn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-design",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96,45.9a7.6,7.6,0,0,0-5.1-7.2V20.3A10.2,10.2,0,0,0,80.7,10.1C70.3,19.1,58,30.6,37.2,30.6H11.7A7.6,7.6,0,0,0,4,38.2V53.6a7.6,7.6,0,0,0,7.7,7.6h6.9c-3,10.3.4,18.6,3,26.8a3.9,3.9,0,0,0,1.6,2c3.3,2.1,10.9,2.5,14.9.8a3.8,3.8,0,0,0,1.2-6.3c-2.9-2.8-4.8-5.9-3.1-9.7a2.1,2.1,0,0,0-.2-1.9c-2.6-3.9-.6-9.9,4.6-11.6,18.7,1.2,30.3,11.9,40.1,20.4A10.3,10.3,0,0,0,90.9,71.4V53.1A7.6,7.6,0,0,0,96,45.9ZM80.7,68.2c-8.8-7.2-20-14.8-35.8-16.7V40.3c15.8-1.9,27-9.6,35.8-16.7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullhorn);
export default __webpack_public_path__ + "static/media/bullhorn.fa3b3e7b.svg";
export { ForwardRef as ReactComponent };